import { useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKey } from '../constants/queryKey';
import {getNoticeDictList} from '../api/dashboard';
import {DashboardNoticeDictList} from "../model/api/dashboard";

export function useNoticeDictList() {
	const queryClient = useQueryClient();
	const key = queryKey.noticeDictList;

	const getData = useQuery<DashboardNoticeDictList>(key, getNoticeDictList);
	const refetch = () => queryClient.invalidateQueries(key);

	return { refetch, getData };
}

